import { useCallback, useSyncExternalStore } from 'react';
import { breakpoints } from '@/theme';

// useSyncExternalStore is the right primitive here: matchMedia is an external
// store and subscribing via useEffect was tearing-prone under concurrent
// rendering. The subscribe/getSnapshot/getServerSnapshot trio is what React's
// own docs call out as the matchMedia migration example.
export function useIsMobile(maxWidth: number = breakpoints.mobileWidth): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const subscribe = useCallback((onChange: () => void) => {
    const mq = window.matchMedia(query);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  const getSnapshot = useCallback(
    () => (typeof window !== 'undefined' && window.matchMedia(query).matches),
    [query],
  );
  // SSR fallback: assume desktop until hydration.
  const getServerSnapshot = () => false;
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
